
const toggleCategoryMenu = (trigger, open = false) => {
  const isClosed = trigger.hasClass("closed");
  const toggle = () => {
    trigger.toggleClass("closed");
    trigger.parent(".sub-menu").children("ul").slideToggle("100");
  }
  
  if (open && isClosed) {
    toggle();
    return;
  }

  if (isClosed) return;

  toggle();
}

// mobile menu
(function ($) {
  "use strict";
  // banner-slider
  jQuery(".testimonials").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
  });

  // toggle-footer
  jQuery(".toggle-footer").click(function () {
    jQuery(".footer-menu").slideToggle(300).toggleClass("open");
    jQuery(this).toggleClass("open");
  });

  //side-bar category

  $(".sub-menu ul").show();

  $(document).on('click', '.sub-menu > a', function (e) {
    toggleCategoryMenu($(this), true)
  })
  

  $(".childvclick").click(function () {
    $(".child").slideToggle("100");
  });
  // For max-width 767
})(jQuery);

jQuery(window).on("load resize",function(e){
  	if (window.matchMedia("(max-width : 767px)").matches) {
      toggleCategoryMenu(jQuery(".sub-menu > a"))
      jQuery(".dskonly").css("color", "black");
    } else {
      jQuery(".dskonly").css("color", "white");
      jQuery(".dskonly").css("margin", "0px");
    }   


  	$('.fileDownloadPromise1').on('click',function(event){
     event.preventDefault()
   let downloadlink = $(this).attr('href');
   console.log(downloadlink);
   var x=new XMLHttpRequest();
	x.open("GET", $(this).attr('href') , true);
	x.responseType = 'blob';
	x.onload=function(e){download(x.response, "download.pdf", "text/plain" ); }
	x.send();
})
    
    
  	$('.fileDownloadPromise2').on('click',function(event){
     event.preventDefault()
   let downloadlinkk = $(this).attr('href');
   console.log(downloadlinkk);
   var x=new XMLHttpRequest();
	x.open("GET", $(this).attr('href') , true);
	x.responseType = 'blob';
	x.onload=function(e){download(x.response, "download.pdf", "text/plain" ); }
	x.send();
 


}) 
    var windowWidth = $(window).width();
    //console.log(windowWidth);
//       // 2- For all devices under or at 768px, use horizontal orientation
//       if(windowWidth < 992) {
        
        
        
//         $('.slider-nav').slick({
//           vertical: false,
//           slidesToShow: 3
//         });
//       } 
//       // 3- For all devices over 768px, use vertical orientation
//       else {
//         $('.slider-nav').slick({
//           vertical: true,
//         });
//       }

  
});

//Get Cookies ajax 

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


// var ol_id = '';
// function collect_recentproducts(){

//     ol_id = getCookie('product_id');
//     if(ol_id == ""){

//       if(typeof meta.product != "undefined"){

// 				ol_id += meta.product.id;
//                 document.cookie = 'product_id='+ol_id;
//       }
        

//     }else{

//       if(ol_id != meta.product.id){	
//         ol_id += '|';
//   		ol_id += meta.product.id;
//         document.cookie = 'product_id='+ol_id;

//     }
    

//     }
//    return false;

// }


//product page js

$(document).ready(function(){
  
  /*-------------MENU ------*/
  
  $('.cc_mneu').css('display','none');
  $('.child').css('display','none');
  
  
  $('.havechilds').on('click', function () {
			
                $('.cc_mneu').css('display','block');
		})
  /*-------------MENU ------*/
  
  jQuery(".dskonly").css('color','white');
  jQuery(".dskonly").css('margin','0px');
  
  
  // Remove atter frpm footer logo 
  setInterval(function(){
  
   // Remove atter frpm footer logo 
         $('.fot').removeAttr('rel');
			// Remove atter frpm footer logo 
          $('.fot').removeAttr('aria-describedby');
  
  
  }, 1000);
        
 // hover dropdown menu   
 $('.site-nav--has-dropdown').hover(function() {
   $('.cc_mneu').css('display','none');
    //$(this).children('ul').stop(true, false, true).slideToggle(300);
    $(this).toggleClass("site-nav--active-dropdown");
 });

  
          
          
           // Product page javascript 
           $("input[name='color-swatch']").click('on',function(){
                        if(!$('.option_value').hasClass('active')){
                          alert('Please select the quantity for the required size!');
                          return false;
                        }
                        let option_2 = $(this).val().replace(/\s/g, "");
                        //Show selected color js
                        $('.colsl_cc').html("COLOUR: "+option_2);
          
                        let option_1 = '';

                        // check option one value
                        $('.option_value').each(function(){
                            if($(this).hasClass('active')){
                             option_1  = $(this).data('opvalue').replace(/\s/g, "");
                            }
                        });

                        // Get color + size name form switch list
                      // console.log('active' + option_1 + '/' + option_2);
                        let needtochecked = option_1 + '/' + option_2;
         
                       setvr(needtochecked);


          });
  
  
       // Product page javascript 
        $('.option_value').on('click', function(){
          
          // Now version Chamged start again with
             
          //Make version deactive
                  $('.option_value').each(function(){
                    $(this).css('color', '#060028');
                    $(this).removeClass('active');
                });
          
                // Disable all qty box 
                $('.option_one_row').each(function(){
                    //$(this).find('select').prop('disabled', 'true');
                   //$(this).find('select').val('1');
                    $(this).find('select').removeClass('active');
                });
          
          
                // Add active class on current variant
                $(this).addClass('active');
                $(this).css('color', 'red');
          
                // Active current row qty box 

                //$(this).next().next('td').find('select').removeAttr("disabled")
                //$(this).next().next('td').find('select').val('1');
                $(this).next().next('td').find('select').addClass('active');
          
          
          
                // Get color name form switch list
                let option_1 = $(this).data('opvalue').replace(/\s/g, "");
                let option_2 = $("input[name='color-swatch']:checked").val()?.replace(/\s/g, "");
                   //console.log('active :: '+option_1+'/'+option_2);
          
                // Select final option 
                let needtochecked = option_1+'/'+option_2;
                // Set variations 
                setvr(needtochecked);
                // Set Qunty
                let ltsqty = $(this).next().next('td').find('select').val();
          
                //console.log(ltsqty);
                  if(ltsqty < 0){

 						$('#Quantity-ajx').val('1');

                  }else{
                       $('#Quantity-ajx').val(ltsqty);
                  }
   
        });
    

      
        // setvrtmatrix();
          
		
        // Correct Proce and SKU 

           $('.option_value').each(function(){
 
             
             
            let exact_price = '';
            let exact_sku = '';
            let a = $(this).data('opvalue').replace(/\s/g, "");
            let b = $('.color-swatch-list input[type=radio]').eq(0).val()?.replace(/\s/g, "");
            let firstvrt = a + '/' + b;
           
            $("select#frenkeltextiles-vart option").each(function () {
              if ($(this).text() == firstvrt){ 
        
                
                   let vid_pp_sku = $(this).val();
                   $("select#frenkeltextiles-price option").each(function () {
                        if ($(this).val() == vid_pp_sku) {
                            //console.log($(this).text());
                            exact_price = $(this).text();
                        }
                    });
                   $("select#frenkeltextiles-sku option").each(function () {
                        if ($(this).val() == vid_pp_sku) {
                            //console.log($(this).text());
                            exact_sku = $(this).text();
                        }
                    });
                
                
                
                }// EDITED THIS LINE
       
             
          });
           
          $(this).next().html('').append(exact_price);
          $(this).prev().html('').append(exact_sku);
          //console.log(exact_price);
          //console.log(exact_sku);

	});

  
  
  ///For Qty selction  Update the final quantity 
  $('.qty-custome-sets').change(function(){

        let newqty =  $(this).val();
       // console.log(newqty);

                $('.qty-custome-sets').each(function(){
                  if($(this).hasClass('active')){
                      $(this).removeClass('active');
                      $(this).val("-1");
                  }
               });
		   $(this).addClass('active').val(newqty);
           if(newqty < 0){
                $('#Quantity-ajx').val('1');
           }else{
               $('#Quantity-ajx').val(newqty);
           
           }

         $(this).parent().prev().prev().addClass('active').click();

  });
  


  
  
  

     
  });


/*!
	Zoom 1.7.18
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function(o){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};o.zoom=function(t,n,e,i){var u,c,a,r,m,l,s,f=o(t),h=f.css("position"),d=o(n);return t.style.position=/(absolute|fixed)/.test(h)?h:"relative",t.style.overflow="hidden",e.style.width=e.style.height="",o(e).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:e.width*i,height:e.height*i,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){c=f.outerWidth(),u=f.outerHeight(),n===t?(r=c,a=u):(r=d.outerWidth(),a=d.outerHeight()),m=(e.width-c)/r,l=(e.height-u)/a,s=d.offset()},move:function(o){var t=o.pageX-s.left,n=o.pageY-s.top;n=Math.max(Math.min(n,a),0),t=Math.max(Math.min(t,r),0),e.style.left=t*-m+"px",e.style.top=n*-l+"px"}}},o.fn.zoom=function(n){return this.each(function(){var e=o.extend({},t,n||{}),i=e.target&&o(e.target)[0]||this,u=this,c=o(u),a=document.createElement("img"),r=o(a),m="mousemove.zoom",l=!1,s=!1;if(!e.url){var f=u.querySelector("img");if(f&&(e.url=f.getAttribute("data-src")||f.currentSrc||f.src),!e.url)return}c.one("zoom.destroy",function(o,t){c.off(".zoom"),i.style.position=o,i.style.overflow=t,a.onload=null,r.remove()}.bind(this,i.style.position,i.style.overflow)),a.onload=function(){function t(t){f.init(),f.move(t),r.stop().fadeTo(o.support.opacity?e.duration:0,1,o.isFunction(e.onZoomIn)?e.onZoomIn.call(a):!1)}function n(){r.stop().fadeTo(e.duration,0,o.isFunction(e.onZoomOut)?e.onZoomOut.call(a):!1)}var f=o.zoom(i,u,a,e.magnify);"grab"===e.on?c.on("mousedown.zoom",function(e){1===e.which&&(o(document).one("mouseup.zoom",function(){n(),o(document).off(m,f.move)}),t(e),o(document).on(m,f.move),e.preventDefault())}):"click"===e.on?c.on("click.zoom",function(e){return l?void 0:(l=!0,t(e),o(document).on(m,f.move),o(document).one("click.zoom",function(){n(),l=!1,o(document).off(m,f.move)}),!1)}):"toggle"===e.on?c.on("click.zoom",function(o){l?n():t(o),l=!l}):"mouseover"===e.on&&(f.init(),c.on("mouseenter.zoom",t).on("mouseleave.zoom",n).on(m,f.move)),e.touch&&c.on("touchstart.zoom",function(o){o.preventDefault(),s?(s=!1,n()):(s=!0,t(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(o){o.preventDefault(),f.move(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0])}).on("touchend.zoom",function(o){o.preventDefault(),s&&(s=!1,n())}),o.isFunction(e.callback)&&e.callback.call(a)},a.src=e.url})},o.fn.zoom.defaults=t})(window.jQuery);
 
  $(document).ready(function(){


		// SLICK
       $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.slider-nav',
        arrows: false,
        adaptiveHeight: true
      });
      $('.slider-nav').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          asNavFor: '.slider-for',
         dots: true,
         arrows: true,
        focusOnSelect: true
      });

      // ZOOM
      $('.ex1').zoom();

      // STYLE GRAB
     $('.ex2').zoom({ on:'grab' });

      // STYLE CLICK
      $('.ex3').zoom({ on:'click' });	

      // STYLE TOGGLE
     $('.ex4').zoom({ on:'toggle' });

     })


function vrt_changed_clicked(){

              $('.qty-custome-sets').each(function(){
                  if($(this).hasClass('active')){
                      $(this).removeClass('active');
                      $(this).val("-1");
                  }
               });

   return true;
}





function setvr(needtochecked){  

                            var needtochecked  = needtochecked;
                                $("select#frenkeltextiles-vart option").each(function(){
                                  
                                   //console.log(needtochecked);
                                  
                                   if ($(this).text() == needtochecked){ // EDITED THIS LINE
                                        $('#itsfinal').val($(this).val());
                                         let svertid = $(this).val();
                                         setrp_price(svertid);
                                         setrp_sku(svertid);
                                         
                                       // console.log(needtochecked);
                                   }
                                });
  
                        return false;
}



function setrp_price(svertid){

					var svertid  = svertid;
                        $("select#frenkeltextiles-price option").each(function(){
                           
                           if ($(this).val() == svertid){ // EDITED THIS LINE
                               
                               $('td.option_value.active').next().html('').text($(this).text())
                             //   console.log($(this).val());
                           }
                        });
return false;


}

function setrp_sku(svertid){

					var svertid  = svertid;
                        $("select#frenkeltextiles-sku option").each(function(){
                           
                           if ($(this).val() == svertid){ // EDITED THIS LINE
                               
                               $('td.option_value.active').prev().html('').text($(this).text())
                                //console.log($(this).val());
                           }
                        });
					return false;


}

function set_new_qty(){




}

function seturl(){

var newurl =
                    window.location.protocol +
                    '//' +
                    window.location.host +
                    window.location.pathname +
                    '?variant='+$(this).val();
                  window.history.replaceState({ path: newurl }, '', newurl);


}


function setvrtmatrix(){
 
  if($('.option_value').length > 0){  
      $('.option_value').each(function(){
            var exact_price = '';
            var exact_sku = '';
            let a = $(this).data('opvalue').replace(/\s/g, "");
            let b = $('.color-swatch-list input[type=radio]').eq(0).val()?.replace(/\s/g, "");
            let firstvrt = a + '/' + b;
           
            
        
            $("#frenkeltextiles-vart option").each(function () {
              
                   console.log(firstvrt);
				   console.log($(this).text());	
                   console.log($(this).val());
              
              
              if ($(this).text() == firstvrt){ 
        
                   console.log(firstvrt);
				   console.log($(this).text());	
                   console.log($(this).val());
                
                   let vid_pp_sku = $(this).val();
                   exact_price = ret_price(vid_pp_sku);
                 
                   exact_sku = ret_sku(vid_pp_sku);
                  

                
                
                }// EDITED THIS LINE
       
             
          });
           
          $(this).next().html('').append(exact_price);
          $(this).prev().html('').append(exact_sku);
	});
  }
}



function ret_price(vid_pp_sku){
        var vid_pp_sku = vid_pp_sku;
        var exact_price = '';
        $("#frenkeltextiles-price option").each(function () {
                        if ($(this).val() == vid_pp_sku) {
                            
                            exact_price = $(this).text();
                        }
                    });
       return exact_price;

}

function ret_sku(vid_pp_sku){
		var exact_sku ='';
        var vid_pp_sku = vid_pp_sku;
  
         $("#frenkeltextiles-sku option").each(function () {
                       if ($(this).val() == vid_pp_sku) {
                            
                            exact_sku = $(this).text();
                        }
                    });
       return exact_sku;
}


  // Onload set default as highlighted
           $(document).ready(function(){ 
            
             $('.option_value').eq(0).addClass('active').click();
            });
            
